import React from 'react';
import CustomPostLink from 'components/CustomLink/CustomPostLink';
import CustomRealisationLink from 'components/CustomLink/CustomRealisationLink';

import { main as MagdaSzymonMain, jakiKolSuk, jesDekoKość, jesWes01, jesWes02, jesWes03, jesWes03A, jesWes04, jesWes05, jesWes06, jesWes07, jesWes08, jesWes09, jesWes11, jesWes12, jesWes13, jesWes14, jesWes15, jesWes16, jesWesInsp, motPrzewWeJes, stylNaWesJes, sukienkaNaJesWes, sukienkiNaWesJes, zaprNaSlubJes01, zaprNaSlubJes02, zaprNaSlubJes03, wesJes01, wesJes02, wesJes03, wesJes04, wesJes05, butyNaWesJes } from "../OurCouplesPics/MagdaSzymon/index"

export const MagdaAndSzymon = {
    bgColor: "bgPink",
    title: "Jesienne wesele Magdy i Szymona",
    path: "slub-jesienia-wesele",
    minHeight: true,
    seoTitle: "Ślub jesienią | jesienne wesele inspiracje",
    seoText: "Planujesz organizację ślubu i wesela jesienią? Zobacz naszą realizację, inspiracje i pomysły na jesienne wesele.",
    mainPic: {
        src: MagdaSzymonMain
    },
    details: "Tego dnia wydarzyło się wiele pięknych rzeczy, a Stara Kruszarnia zadrżała w posadach od tańców do białego rana. Było oryginalnie i kolorowo i to nie tylko za sprawą pięknej jesiennej aury otaczającej Złoty Stok.",
    org: "Agencja Ślubna Czary Marry",
    orgLink: "",
    place: "Stara Kruszarnia",
    placeLink: "http://sk.kopalniazlota.pl/",
    photo: "Krzysiek Kudła",
    photoLink: "https://kudlakrzysiek.pl/",
    flowers: "Anello Decor",
    flowersLink: "https://www.facebook.com/anellodecor/",
    date: '17 mar 2022',
    textMain: <>Tego dnia wydarzyło się wiele pięknych rzeczy, a Stara Kruszarnia zadrżała w posadach od tańców do białego rana. Było oryginalnie i kolorowo i to nie tylko za sprawą pięknej jesiennej aury otaczającej <span className='pink bold'>Złoty Stok</span>.<br /><br />
        Magdę i Szymona pokochałyśmy od pierwszego spotkania. Wiedziałyśmy, że z nimi nie będziemy się nudzić i wyczarujemy coś niezwykłego. Za każdym razem, gdy się z nimi spotykałyśmy, miałyśmy wrażenie, że spędzamy czas z bliskimi znajomymi, a nie klientami. Otwarci, sympatyczni, spontaniczni, pełni zaufania i zrozumienia naszej pracy.
    </>,
    topPic: {
        src: MagdaSzymonMain
    },
    content: [
        {
            headerClassName: "pink",
            headerSmall: 'Jesienne wesele — świadoma decyzja, czy kwestia przypadku.',
            text: <>Propozycji miejsc weselnych było wiele, odwiedziliśmy wspólnie kilka z nich, ale ostatecznie para młoda zdecydowała się na Starą Kruszarnię. Najbliższy wolny termin to 23 października 2021 roku. Pojawiły się chwilowe wątpliwości. Magda i Szymon marzyli o ceremonii na zewnątrz i dekoracjach w kolorze lata. Czy to się uda? Czy pogoda nie pokrzyżuje nam planów? Szybko przekonałyśmy Magdę i Szymona, że ślub jesienią może być równie piękny, co ten w środku lata, a jesienne wesele ma wiele plusów.<br /><br />
                Jesienne wesele plusy:
                <ul style={{ marginTop: ".5rem" }}>
                    <li>Większa dostępność wykonawców i miejsc weselnych.</li>
                    <li>Złota polska jesień to najpiękniejsza dekoracja.</li>
                    <li>Nie jest za gorąco.</li>
                    <li>Większa dostępność gości - wakacje potrafią znacznie wpłynąć na frekwencję.</li>
                    <li>Pyszna kuchnia sezonowa.</li>
                </ul>
            </>,
            pics: [
                {
                    src: butyNaWesJes
                }
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Jesienne wesele — pogoda, która potrafi płatać figle.",
            text:
                <>
                    Czy należy się obawiać, że organizując wesele jesienią, pogoda może pokrzyżować nasz <CustomPostLink path='plan-wesela-harmonogram-dnia-slubu-krok-po-kroku' className='linkPink' text='plan dnia ślubu' />? Teoretycznie tak, podobnie, gdy organizujemy wesele wiosną, latem, czy zimą. Miałyśmy okazję koordynować deszczowe wesela w lecie i słoneczne ceremonie plenerowe w zimie. Najważniejsze, by nie dać się zwariować. W zeszłym roku zorganizowałyśmy pięć jesiennych wesel. Pogoda była różna, ale ani razu nie pozwoliliśmy jej na psucie atmosfery. 23 października był dniem, w którym deszcz na zmianę zastępowało piękne słońce. Do ostatniej sekundy czekaliśmy na decyzję, gdzie odbędzie się ceremonia. Ponieważ zaplanowaliśmy ceremonię humanistyczną, mogliśmy sobie pozwolić na elastyczność. Postanowiliśmy z parą, że jeśli w ciągu 15 minut się nie wypogodzi, zaczniemy obiadem, a ceremonię przełożymy na później. Poprosiliśmy zebranych gości o chwilę cierpliwości. Nikt nie protestował, goście rozmawiali ze sobą i czekali na decyzję. Gdy tylko wyszło słońce i deszcz przestał padać, rozdaliśmy gościom parasolki i koce. Ostatecznie ruszyliśmy z pięciominutowym opóźnieniem. Celebrant poinformował, że jeśli znowu zacznie padać, robimy akcję ewakuację i kończymy na sali. Okazało się, że tego dnia więcej nie padało. Być może pomyślicie, że panował zamęt i dezinformacja. Nie zgodzimy się z tym, to było totalnie naturalne, na luzie, para dobrze czuła się z takim rozwiązaniem, nikt się nie stresował, nigdzie się nam nie spieszyło.
                </>,
            pics: [
                {
                    src: jesWes11
                },
                {
                    src: jesWes12
                },
                {
                    src: jesWes13
                },
                {
                    src: jesWes14
                },
                {
                    src: jesWes15
                }
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Ślub jesienią — ceremonia humanistyczna.",
            text:
                <>Pamiętamy, jak Magda z Szymonem zapytali, co myślimy o tym, żeby ceremonię humanistyczną poprowadził ich przyjaciel Mateusz. Uznałyśmy, że to świetny pomysł, ale wiedziałyśmy, że to bardzo odpowiedzialne i trudne zadanie. Chwilę później umówiliśmy się z parą i Mateuszem na spotkanie. Wtedy zrozumiałyśmy, dlaczego Magda z Szymonem chcieli powierzyć tę funkcję właśnie jemu. Wspólnie omówiliśmy <CustomPostLink path='5-hey-wedding-ślub-humanistyczny-a-na-co-to-komu' className='linkPink' text='założenia i idee ślubu humanistycznego' />. Mateusz przygotował scenariusz, który wysłał nam do konsultacji, jego treść miała być niespodzianką dla pary. Ceremonia powaliła parę, gości i nas na kolana. Była zabawna, wzruszająca i pełna osobistych nawiązań.
                </>,
            pics: [
                {
                    src: jesWes16
                },
                {
                    src: jesWesInsp
                },
                {
                    src: motPrzewWeJes
                },
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Jesienne wesele a plener ślubny.",
            text: "Należy pamiętać, że jesienne wesele to nie tylko wrzesień, ale także październik czy listopad. Im bliżej końca roku tym dni stają się krótsze, a co za tym idzie, możemy nie zdążyć ze zdjęciami plenerowymi przed zachodem słońca. Dlatego podczas jesiennych realizacji sugerujemy parom zaplanowanie first looku połączonego z dłuższą sesją plenerową przed ceremonią. Zwykle planujemy na nią około 40 minut do godziny. To piękny czas, który pozwoli Wam wejść w weselny klimat, wyciszyć się i spędzić chwilę czasu tylko we dwoje. Krótka sesja zorganizowana po obiedzie, czy pierwszym tańcu będzie wartością dodaną. Jeśli nie zdążycie się na nią wybrać, nic nie szkodzi.",
            pics: [
                {
                    src: jesDekoKość
                },
                {
                    src: jakiKolSuk
                }
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Sukienka na jesienne wesele — na co się zdecydować.",
            text: <>Naszym zdaniem należy ubrać się komfortowo. Szkoda byłoby ryzykować przeziębieniem tylko po to, żeby zaprezentować się w sukni z odkrytymi ramionami, która nie jest dostosowana do aury panującej na zewnątrz. Radzimy wybrać <CustomPostLink path='suknia-slubna-jak-wybrac' text='suknię' className='linkPink' /> z długim rękawem lub ciekawe okrycie wierzchnie. Jeśli pójdziecie w to drugie, opcji jest bardzo wiele, wszystko zależy od stylu samej sukienki i przyjęcia. Do bardziej eleganckich stylizacji świetnie sprawdzą się futerka lub wełniane etole, do luźniejszych kurtki, katany i ramoneski. Kolor sukienki na wesele jesienią powinien być dostosowany do karnacji i typu urody panny młodej, ale wszelkiego rodzaju kremy czy beże, nieco lepiej wpiszą się w kolory jesieni. Wybierając buty na wesele jesienią, postawcie na wygodę i odrzućcie sandałki na bok. Nie tylko będzie Wam zimno, ale mogą się okazać niebezpieczne.</>,
            pics: [
                {
                    src: stylNaWesJes
                }
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Garnitur na jesienne wesele — na co się zdecydować.",
            text: "To istny raj dla panów, którzy chcieliby postawić na nieoczywiste wybory. Możecie zaszaleć ze strukturą i wybrać nieco grubszy materiał, dodać do stylizacji kamizelkę lub szelki. W klimat jesiennych wesel świetnie wpisują się kolory takie jak śliwkowy, brązowy, czy bordo, możecie też zdecydować się na kratę jak nasz pan młody Szymon.",
            pics: [
                {
                    src: sukienkiNaWesJes
                },
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Jesienne wesele a zabawa na parkiecie.",
            text: <>Wspominałyśmy już, że, organizacja wesela jesienią wymusza na nas pewne rozwiązania. Nie da się ukryć, wieczory są chłodne, a dni krótsze. Jednak dla wielu osób mogą to być idealne warunki do rozkręcenia niesamowitej zabawy na parkiecie. Jeśli przeraża Was, że goście rozejdą się po <CustomPostLink text='ogrodzie' path='wesele-w-ogrodzie-garden-party' className='linkPink' />, nie będą tańczyć do momentu aż zapadnie półmrok, to jesienne wesele jest idealnym rozwiązaniem dla Was. Goście będą wychodzić wyłącznie na papierosa i szybko wracać na salę, a impreza rozkręci się znacznie szybciej, niż ma to miejsce w lecie.</>,
            pics: [
                {
                    src: sukienkaNaJesWes
                },
                {
                    src: wesJes01
                },
                {
                    src: wesJes02
                },
                {
                    src: wesJes03
                },
                {
                    src: wesJes04
                },
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Ślub jesienią - dekoracje.",
            text: <>Jesienne wesele zachwyca kolorami. Soczyste pomarańcze, brązy, żółcienie, bordo to typowe kolory jesieni. Czy jest to jednak jedyne rozwiązanie? Organizując ślub jesienią, nie musicie się ograniczać wyłącznie do tego <CustomPostLink text='motywu przewodniego' path='motyw-przewodni-wesela' className='linkPink' />. Jesienne wesele to nie tylko dynie, jarzębina i spadające liście. Wszystko zależy, jak opowiecie swoją historię i czy uda Wam się wprowadzić gości w odpowiedni klimat. Dla przykładu nasza panna młoda Magda marzyła o letnich kolorach i nietuzinkowych dekoracjach. Postanowiliśmy wyczarować coś energetycznego i oryginalnego. Postawiliśmy na kaktusy w ceramicznych osłonkach i kwiaty w odcieniach intensywnego różu, zieleni, pomarańczy i żółtego. Goście byli oczarowani tym kontrastem. Ceglane, industrialne wnętrze Kruszarni po raz kolejny okazało się niezwykle plastycznym tłem dla dekoracji. Ciężko było uwierzyć, że zaledwie tydzień wcześniej jej wnętrza zamieniliśmy w kosmiczną przestrzeń pełną gwiazd i astronomicznych nawiązań dekorując salę na przyjęcie Angeliki i Daniela. Pełny reportaż z tego wesela znajdziecie tutaj - <CustomRealisationLink text='wesele w Starej Kruszarni' path='stara-kruszarnia-wesele-kosmos' className='linkPink' />.</>,
            pics: [
                {
                    src: jesWes01
                },
                {
                    src: jesWes02
                },
                {
                    src: jesWes03
                },
                {
                    src: jesWes03A
                },
                {
                    src: jesWes04
                },
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Jesienne kwiaty na wesele.",
            text: "Zazwyczaj zachęcamy do wyboru sezonowych roślin. Ma to wpływ na dostępność, jakość oraz cenę kwiatów. Dalie i chryzantemy to zdecydowanie królowe jesieni. Mimo to podczas tworzenia dekoracji poszliśmy w zupełnie innym kierunku. Naszą królową była protea, czyli narodowy symbol RPA, to właśnie tam wychowała się nasza panna młoda. Ten spektakularny, duży kwiat stał się główną ozdobą jej bukietu. Do tego wcześniej wspomniane kaktusy na stołach uzupełnione pojedynczymi kwiatami w szklanych buteleczkach. Nad głową pary młodej zawiesiliśmy trzy wiklinowe kosze, z których wprost wylewały się kwiaty opadające w dół.",
            pics: [
                {
                    src: jesWes05
                },
                {
                    src: jesWes06
                },
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Jesienne wesele — tekstylia i dodatki.",
            text: "Naszym weselnym must have są zdecydowanie kolorowe obrusy lub bieżniki. Rezygnacja z popularnej bieli może zadziałać cuda. Dobrze dobrana struktura materiału oraz kolor podbije efekt nawet skromnych dekoracji. Wypożyczalnie dysponują ogromną ilością barw, warto przemyśleć taki wydatek. Podczas organizacji wesela Magdy i Szymona dobór kolorów był tematem numer jeden, chwilami spędzał nam sen z powiek. Ostatecznie wyszło pięknie i oryginalnie. Na stołach gości postawiliśmy na łososiowe bieżniki, stół pary młodej zdobił musztardowy obrus, do tego serwety w kolorze butelkowej zieleni. Całość uzupełniliśmy wiklinowymi podkładkami. Brzmi jak szaleństwo? Przyznajcie, że wyszło pięknie.",
            pics: [
                {
                    src: jesWes07
                },
                {
                    src: jesWes08
                },
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Zaproszenia na ślub jesienią.",
            text: "Była już mowa o wprowadzenie gości w odpowiedni klimat jesiennego wesela. Najlepszą zapowiedzią tego, co może ich czekać, jest samo zaproszenie. Zawsze powinno ono nawiązywać do motywu przewodniego wesela. Dlatego najpierw planujemy dekoracje, a dopiero później zabieramy się za papeterię. W tym przypadku postawiliśmy na kolory przewodnie naszego jesiennego wesela, wyszło dość odważnie. Intensywny pomarańczowy, łososiowy oraz butelkowa zieleń. Mimo tak nieoczywistych kolorów zarówno para młoda, jak i goście byli zachwyceni. Podobne kolory pojawiły się w papeterii na weselu. Naszego pomarańczowego table planu nie sposób było przegapić.",
            pics: [
                {
                    src: jesWes09
                },
                {
                    src: zaprNaSlubJes01
                },
                {
                    src: zaprNaSlubJes02
                },
                {
                    src: zaprNaSlubJes03
                },
            ]
        },
        {
            headerClassName: "pink",
            headerSmall: "Jesienne wesele — menu.",
            text: "Najlepsze zostawiliśmy sobie na koniec. Tu możecie naprawdę zaszaleć. Świetnie sprawdzą się wszelkiego rodzaju rozgrzewające zupy-kremy jak dyniowa, marchewkowa, ziemniaczana. Warto przemyśleć również borowikową, ale z doświadczenia wiemy, że jest sporo osób, które nie tolerują grzybów. Mogą się one również pojawić w daniu głównym czy kolacji, ważne, żeby nie było ich za dużo, ponieważ są ciężkostrawne. Fajnym rozwiązaniem jest serwowanie faszerowanych warzyw lub mięs w towarzystwie sezonowych owoców jak jabłko, gruszka czy śliwka. Owoce te warto też przemycić w deserach.",
            pics: [
                { src: wesJes05 },
            ]
        },
        {
            text: "Jeśli jesteście zainteresowani organizacją jesiennego wesela, zapraszamy do kontaktu. Chętnie zorganizujemy dla Was również wesele wiosną, latem czy jesienią. Jesteśmy przekonane, że o każdej porze roku możemy wyczarować coś niesamowitego i po Waszemu."
        },
    ],
    extras: <>Może zainteresować Cię również:
        <ul style={{ marginTop: ".5rem" }}>
            <li><CustomPostLink text="Znowu musimy przełożyć wesele - Rozmowa z Beatą i Pawłem." path="11-hey-wedding-musze-przelozyc-wesele-z-powodu-koronawirusa" className="linkPink" /></li>
            <li><CustomPostLink text="Ekipa marzeń i kosmiczne wesele - Rozmowa z Angeliką i Danielem." path="19-hey-wedding-ekipa-marzen-i-kosmiczne-wesele" className="linkPink" /></li>
            <li><CustomPostLink text="Wesele w Folwarku Wąsowo" path="folwark-wasowo-wesele" className="linkPink" /></li>
            <li><CustomPostLink text="Wesele w Zamku Książ" path="zamek-ksiaz-wesele-motyw-rose-gold" className="linkPink" /></li>
            <li><CustomPostLink text="Ślub i wesele w górach - organizacja + lista miejsc." path="slub-wesele-w-gorach" className="linkPink" /></li>
        </ul>
    </>
}